export var beaconTheme = {
  baseStyle: {
    // This wrapper is to prevent the beacon animation from affecting the popover position.
    beaconWrapper: {
      width: '24px',
      height: '24px',
      // Resets the button styles.
      padding: 'none',
      border: 'none',
      backgroundColor: 'transparent',
      outline: 'none'
    },
    beacon: {
      backgroundColor: 'brand.lighter',
      height: '24px',
      width: '24px',
      borderRadius: 'full',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    beaconDot: {
      bgColor: 'brand.dark',
      height: '8px',
      width: '8px',
      borderRadius: 'full'
    }
  }
};
//# sourceMappingURL=Beacon.theme.js.map